import {localization} from "@/common/lang/localization";

function validateRequiredFields(form, validations) {
    let isValid = true;

    for (let field in form) {
        let validation = validations[field];

        if (!form.hasOwnProperty(field) || !validations.hasOwnProperty(field) || !(validation.required || validation.checked || validation.checked_any || validation.required_property)) {
            continue;
        }

        let value = form[field];

        if (validation.required) {
            isValid &= validateRequiredValue(value);
        }

        if (validation.checked) {
            isValid &= validateCheckedValue(value);
        }

        if (validation.checked_any) {
            const requiredAnyConfig = validation.checked_any;
            isValid &= validateCheckedAny(requiredAnyConfig.conditionFunc?.(), requiredAnyConfig.fieldNames, requiredAnyConfig.dataGetter());
        }

        if (validation.required_property && validation.required) {
            isValid &= validateRequiredProperty(value, validation.required_property.name);
        }
    }

    return isValid;
}

function validateForm(self, validator, ignoreFields) {
    return new Promise((resolve, reject) => {
        self.$nextTick(() => {
            let fieldsFilter = undefined;
            if (ignoreFields) {
                fieldsFilter = validator.fields.items.filter(item => {
                        return !ignoreFields.some(ignoredField => {
                            let hasWildcards = ignoredField.includes("*");
                            if (hasWildcards) {
                                let regex = new RegExp(ignoredField);
                                return regex.test(item.name);
                            } else {
                                return ignoredField === item.name;
                            }
                        });
                });
            }

            validator.validateAll(fieldsFilter).then(valid => {
                if (valid) {
                    resolve();
                } else {
                    reject(localization.i18n.t("common.validation.form.hasErrors"));
                }
            });
        });
    });
}

// Required validation check matches vee-validate rule required
function validateRequiredValue(value) {
    let isValid = true;

    if (value === undefined || // value is undefined
        value === null || // value is null
        String(value).trim().length === 0 || // value is empty string
        (value instanceof Array && value.length === 0)) // value is empty array
    {
        isValid &= false;
    }

    return isValid;
}

// Required validation if value itself is an object and needs a specific property
function validateRequiredProperty(value, requiredPropertyKey) {
    return typeof value === "object" && value.hasOwnProperty(requiredPropertyKey) && !!value[requiredPropertyKey];
}

// Validates checkboxes are checked
function validateCheckedValue(value) {
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    if (typeof value === "boolean") {
        return value === true;
    }
    if (typeof value === "number") {
        return value > 0;
    }
    return false;
}

// Validates that at least one field from a group is checked
function validateCheckedAny(condition, fieldNames, data) {
    // If condition is not met, no validation is required, so the evaluation passes
    if (!condition) {
        return true;
    }

    for (let fieldName of fieldNames) {
        let fieldValue = data.hasOwnProperty(fieldName) ? data[fieldName] : false;
        if (validateCheckedValue(fieldValue)) {
            return true;
        }
    }
    return false;
}

// Improvement for interdependent field validation, e.g. checked_any, where changing one field has to call validation on the other fields
function createInterdependentValidationWatchers(self, validator, fieldNames, formPrefix = 'form') {
    fieldNames.forEach(field => {
        const fullPath = (formPrefix ? formPrefix + "." : "") + field;

        self.$watch(fullPath, function() {
            for (const otherField of fieldNames) {
                // Do not validate own field
                if (otherField === field) {
                    continue;
                }
                // Make sure field element is already attached to avoid errors
                if (!validator.fields.find({ name: otherField })) {
                    continue;
                }
                validator.validate(otherField);
            }
        });
    });
}

export {
    validateRequiredFields,
    validateForm,
    validateRequiredValue,
    validateRequiredProperty,
    validateCheckedValue,
    validateCheckedAny,
    createInterdependentValidationWatchers
}